import { IconButton } from '@material-ui/core'
import PlayIcon from '@material-ui/icons/PlayCircleOutlineOutlined'
import Image from 'next/image'
import { useMemo } from 'react'
import { VideoEl } from '../../../../components/file/viewer/components/video/elements'
import useToggle from '../../../../hooks/use-toggle'
import dimensions from '../../../../utils/dimensions'
import { CoverEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Cover = () => {
  const [showVideo, toggleVideo] = useToggle(false)

  const {
    data: { cover, coverVideo },
  } = CourseHomeStore.useContainer()

  const hasCoverVideo = useMemo(() => Boolean(coverVideo), [coverVideo])

  return (
    <CoverEl>
      <div className='container'>
        {!showVideo && (
          <div className='cover'>
            {cover && (
              <Image
                src={cover}
                height={dimensions.dw(95)}
                width={dimensions.dw(95)}
                priority
                quality={66}
              />
            )}
            {hasCoverVideo && (
              <IconButton onClick={() => hasCoverVideo && toggleVideo(true)}>
                <PlayIcon />
              </IconButton>
            )}
          </div>
        )}

        {hasCoverVideo && showVideo && (
          <VideoEl
            url={coverVideo}
            width='100%'
            height='auto'
            controls
            playing
          />
        )}
      </div>
    </CoverEl>
  )
}

export default Cover
